import { ProfileService } from './../../profile.service';
import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { Experience } from '../../types/helpers/experience.model';
import { FormBuilder, Validators } from '@angular/forms';
import { UserDetails } from '../../types/helpers/user-details.model';
import { AddExperienceModalComponent } from '../add-experience-modal/add-experience-modal.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SharedService } from '../../../shared/shared.service';
import { Observable, of } from 'rxjs';
import { environment } from 'projects/mmb-web-app/src/environments/environment';

@Component({
  selector: 'mmb-web-app-user-experience-info',
  templateUrl: './user-experience-info.component.html',
  styleUrls: ['./user-experience-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserExperienceInfoComponent implements OnInit {

  @Input() experiences: Experience[];
  @Input() user: UserDetails;
  @Input() isEditMode: boolean;

  constructor(private modalService: NgbModal,
    private profileService: ProfileService,
    private sharedService: SharedService) { }

  ngOnInit() { }

  onEditExperience(experience) {
    if (this.isEditMode) {
      this.editExperience(experience);
    }
  }

  /**
   * Create experience modal
   */
  addExperience() {
    const modalRef = this.modalService.open(AddExperienceModalComponent, { centered: true });
    modalRef.componentInstance.addSuccess.subscribe((ev) => {
      this.getProfile();
    });
  }
  /**
   * Edit experience modal
   */
  editExperience(experiences) {
    const modalRef = this.modalService.open(AddExperienceModalComponent, { centered: true });
    modalRef.componentInstance.experiences = experiences;
    modalRef.componentInstance.isEditMode = true;
    modalRef.componentInstance.addSuccess.subscribe((ev) => {
      this.getProfile();
    });
  }

  getProfile() {
    this.profileService.getUserProfile().subscribe((response) => {
      this.experiences = response.experiences;
    });
  }

  getOrganisation(item): any {
    if (item && item.organisation) {
      if (item.organisation.logo) {
        return {
          logo: item.organisation.logo
        };
      }
      if (item.organisation.website_url) {
        return {
          websiteUrl: item.organisation.websiteUrl
        };
      }
      return {
        name: item.organisation.name
      };
    }

    // organisation_custom
    if (item && item.organisation_custom) {
      return {
        name: item.organisation_custom
      };
    }

    return {
      name: ''
    };
  }

  getOrgImageUrl(item) {
    if (item) {
      if (item.logo) {
        return item.logo;
      }
      if (item.websiteUrl) {
        return `${environment.api.logoServer}/${item.websiteUrl}`;
      }
    }
  }

}
